/* ==========================================================================
   MILFSHAKES · SCROLL INFINITO EN LISTADOS
   --------------------------------------------------------------------------
   Sustituye la paginación numérica por carga continua. Al acercarse el final
   del listado (con MUCHO margen, ver ROOT_MARGIN) pide la página siguiente a
   la Section Rendering API de Shopify y añade las tarjetas al grid actual.

   Decisiones importantes:
   · La paginación numérica NO se elimina del marcado, solo se oculta. Así
     Google sigue rastreando todas las páginas y, si el JS falla o está
     desactivado, el usuario conserva los enlaces.
   · A las tarjetas añadidas se les quita reveal-on-scroll: el tema las pinta
     con opacity:0 y las revela con un observador propio que no ve los nodos
     insertados después, así que sin esto llegarían invisibles.
   · La URL del navegador NO se cambia al cargar más (antes pasaba a ?page=N y,
     al volver de una ficha, el usuario solo veía esa página). En su lugar se
     guarda en sessionStorage qué páginas se han cargado y el punto de scroll,
     y al volver atrás (o recargar) se vuelven a pedir y se restaura la
     posición.
   ========================================================================== */
(function () {
  if (customElements.get('infinite-scroll')) return;

  // Distancia antes del final a la que se dispara la carga. Alta a propósito:
  // así los productos ya están puestos cuando el usuario llega.
  var ROOT_MARGIN = '1200px 0px';

  // Lo guardado caduca a los 30 minutos: pasado ese tiempo se empieza de cero.
  var MAX_AGE = 30 * 60 * 1000;
  var STORAGE_PREFIX = 'ms-infinite-scroll:';

  function navigationType() {
    try {
      var entry = performance.getEntriesByType('navigation')[0];
      if (entry) return entry.type;
    } catch (e) {}
    return 'navigate';
  }

  function readState(key) {
    try {
      var state = JSON.parse(sessionStorage.getItem(key));
      if (state && Date.now() - state.savedAt < MAX_AGE) return state;
    } catch (e) {}
    return null;
  }

  function writeState(key, state) {
    try {
      state.savedAt = Date.now();
      sessionStorage.setItem(key, JSON.stringify(state));
    } catch (e) {}
  }

  function clearState(key) {
    try { sessionStorage.removeItem(key); } catch (e) {}
  }

  class InfiniteScroll extends HTMLElement {
    connectedCallback() {
      this.list = document.getElementById(this.getAttribute('target'));
      this.nextUrl = this.getAttribute('next-url');
      this.sectionId = this.getAttribute('section-id');
      this.loading = false;

      if (!this.list || !this.nextUrl || !('IntersectionObserver' in window)) return;

      // Clave por listado: la URL en la que se entró (colección, filtros, orden).
      this.storageKey = STORAGE_PREFIX + window.location.pathname + window.location.search;
      this.loadedUrls = [];

      this.pagination = this.parentElement && this.parentElement.querySelector('nav.pagination');
      if (this.pagination) this.pagination.hidden = true;

      this.onPageHide = this.saveScroll.bind(this);
      window.addEventListener('pagehide', this.onPageHide);

      this.observer = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) { this.loadNext(); break; }
        }
      }.bind(this), { rootMargin: ROOT_MARGIN });

      var type = navigationType();
      var saved = (type === 'back_forward' || type === 'reload') ? readState(this.storageKey) : null;

      if (saved && saved.urls && saved.urls.length) {
        this.restore(saved);
      } else {
        clearState(this.storageKey);
        this.observer.observe(this);
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.onPageHide) window.removeEventListener('pagehide', this.onPageHide);
    }

    // Se guarda qué tarjeta estaba arriba del todo en pantalla y a qué
    // distancia, no los píxeles: al volver, la página aún está creciendo
    // (imágenes, banners) y un número de píxeles fijo cae en otro sitio.
    saveScroll() {
      if (!this.loadedUrls.length) return;

      var cards = this.list.children;
      var anchor = -1;
      var offset = 0;
      for (var i = 0; i < cards.length; i++) {
        var rect = cards[i].getBoundingClientRect();
        if (rect.bottom > 0) { anchor = i; offset = rect.top; break; }
      }

      writeState(this.storageKey, { urls: this.loadedUrls, scrollY: window.scrollY, anchor: anchor, offset: offset });
    }

    scrollToSaved(saved) {
      var card = saved.anchor >= 0 ? this.list.children[saved.anchor] : null;
      var y = card ? card.getBoundingClientRect().top + window.scrollY - saved.offset : saved.scrollY || 0;
      window.scrollTo(0, y);
    }

    async fetchPage(pageUrl) {
      var url = new URL(pageUrl, window.location.origin);
      url.searchParams.set('section_id', this.sectionId);

      var response = await fetch(url.toString());
      if (!response.ok) throw new Error('HTTP ' + response.status);

      return new DOMParser().parseFromString(await response.text(), 'text/html');
    }

    appendFrom(doc) {
      var incoming = doc.getElementById(this.list.id) || doc.querySelector('product-list');
      if (!incoming) return;

      var fragment = document.createDocumentFragment();
      Array.prototype.slice.call(incoming.children).forEach(function (node) {
        node.removeAttribute('reveal-on-scroll');
        node.querySelectorAll('[reveal-on-scroll]').forEach(function (el) {
          el.removeAttribute('reveal-on-scroll');
        });
        fragment.appendChild(node);
      });
      this.list.appendChild(fragment);
    }

    finishIfLast() {
      if (!this.nextUrl) {
        this.observer.disconnect();
        this.hidden = true;
      }
    }

    // Vuelve a montar las páginas que el usuario ya había cargado y lo deja
    // en el mismo punto del scroll.
    async restore(saved) {
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      this.loading = true;
      this.setAttribute('loading', '');

      try {
        var docs = await Promise.all(saved.urls.map(this.fetchPage.bind(this)));
        docs.forEach(this.appendFrom.bind(this));

        this.loadedUrls = saved.urls.slice();
        var lastNext = docs[docs.length - 1].querySelector('infinite-scroll');
        this.nextUrl = lastNext ? lastNext.getAttribute('next-url') : null;

        this.dispatchEvent(new CustomEvent('infinite-scroll:loaded', { bubbles: true }));

        // Se recoloca varias veces mientras la página termina de montarse, y se
        // deja de hacer en cuanto el usuario toca el scroll.
        var self = this;
        var stopped = false;
        var stop = function () { stopped = true; };
        ['wheel', 'touchstart', 'keydown'].forEach(function (ev) {
          window.addEventListener(ev, stop, { once: true, passive: true });
        });
        [0, 150, 400, 800, 1500].forEach(function (delay) {
          setTimeout(function () {
            if (!stopped) self.scrollToSaved(saved);
            if (delay === 1500 && 'scrollRestoration' in history) history.scrollRestoration = 'auto';
          }, delay);
        });
      } catch (e) {
        // Si no se puede restaurar, se sigue como una visita normal
        clearState(this.storageKey);
        if ('scrollRestoration' in history) history.scrollRestoration = 'auto';
      } finally {
        this.loading = false;
        this.removeAttribute('loading');
      }

      if (this.nextUrl) this.observer.observe(this);
      else this.finishIfLast();
    }

    async loadNext() {
      if (this.loading || !this.nextUrl) return;
      this.loading = true;
      this.setAttribute('loading', '');

      var pageUrl = this.nextUrl;

      try {
        var doc = await this.fetchPage(pageUrl);
        this.appendFrom(doc);

        var nextEl = doc.querySelector('infinite-scroll');
        this.nextUrl = nextEl ? nextEl.getAttribute('next-url') : null;
        this.loadedUrls.push(pageUrl);
        this.saveScroll();

        this.dispatchEvent(new CustomEvent('infinite-scroll:loaded', { bubbles: true }));
        this.finishIfLast();
      } catch (e) {
        // Si algo falla, se devuelve al usuario la paginación clásica
        if (this.pagination) this.pagination.hidden = false;
        if (this.observer) this.observer.disconnect();
        this.hidden = true;
      } finally {
        this.loading = false;
        this.removeAttribute('loading');
      }
    }
  }

  customElements.define('infinite-scroll', InfiniteScroll);
})();
